// extracted by mini-css-extract-plugin
export default {"textCheckbox":"textCheckbox-eQ5N6","warning":"warning-nUI2R","error":"error-a5asc","accent":"accent-_QZZN","success":"success-s8Hcw"};